// NOTE: van 生产环境为 prod
export const env =
  process.env.NODE_ENV === 'development'
    ? 'stg'
    : document.documentElement.dataset.vanEnv || 'prod';

export const isProd = env === 'prod';

export const API_HOST = {
  stg: 'https://dappweb-stg.xiaolachuxing.com',
  pre: 'https://dappweb-pre.xiaolachuxing.com',
  prod: 'https://dappweb.xiaolachuxing.com',
}[env];

export const SA_HOST = {
  stg: 'https://uba-stg.xiaolachuxing.com/sa?project=xldriver',
  pre: 'https://uba-stg.xiaolachuxing.com/sa?project=xldriver',
  prod: 'https://uba.xiaolachuxing.com/sa?project=xldriver',
}[env];

export const DIC_HOST = {
  stg: 'https://dic-driver-stg.xiaolachuxing.com',
  pre: 'https://dic-driver-pre.xiaolachuxing.com',
  prod: 'https://dic-driver.xiaolachuxing.com',
}[env];

export const DPC_HOST = {
  stg: 'https://dpc-driver-stg.xiaolachuxing.com/api',
  pre: 'https://dpc-driver-pre.xiaolachuxing.com/api',
  prod: 'https://dpc-driver.xiaolachuxing.com/api',
}[env];

export const DRIVER_HOST = {
  stg: 'https://driver-stg.xiaolachuxing.com',
  pre: 'https://driver-pre.xiaolachuxing.com',
  prod: 'https://driver.xiaolachuxing.com',
}[env];

export const DFINANCE_HOST = {
  stg: 'https://dfinance-driver-stg.xiaolachuxing.com',
  pre: 'https://dfinance-driver-pre.xiaolachuxing.com',
  prod: 'https://dfinance-driver.xiaolachuxing.com',
}[env];

export const DCS_API_HOST = {
  stg: 'https://dcs-driver-stg.xiaolachuxing.com/api',
  pre: 'https://dcs-driver-pre.xiaolachuxing.com/api',
  prod: 'https://dcs-driver.xiaolachuxing.com/api',
}[env];

export const DIC_API_HOST = {
  stg: 'https://dic-driver-stg.xiaolachuxing.com/api',
  pre: 'https://dic-driver-pre.xiaolachuxing.com/api',
  prod: 'https://dic-driver.xiaolachuxing.com/api',
}[env];

export const DPC_API_HOST = {
  stg: 'https://dpc-driver-stg.xiaolachuxing.com/api',
  pre: 'https://dpc-driver-pre.xiaolachuxing.com/api',
  prod: 'https://dpc-driver.xiaolachuxing.com/api',
}[env];

export const DRISK_API_HOST = {
  stg: 'https://drisk-stg.xiaolachuxing.com/api',
  pre: 'https://drisk-pre.xiaolachuxing.com/api',
  prod: 'https://drisk.xiaolachuxing.com/api',
}[env];

export const JOIN_HOST = {
  stg: 'https://xl-driver-join-v-stg.xiaolachuxing.com',
  pre: 'https://xl-driver-join-v-pre.xiaolachuxing.com',
  prod: 'https://driver-h5.xiaolachuxing.com/join',
}[env];

export const LUNA_HOST = {
  local: '//luna-upload-stg.xiaolachuxing.com/luna/api',
  dev: '//luna-upload-stg.xiaolachuxing.com/luna/api',
  stg: '//luna-upload-stg.xiaolachuxing.com/luna/api',
  pre: '//luna-upload-pre.xiaolachuxing.com/luna/api',
  gra: '//luna-upload-gra.xiaolachuxing.com/luna/api',
  prd: '//luna-upload.xiaolachuxing.com/luna/api',
  prod: '//luna-upload.xiaolachuxing.com/luna/api',
}[env];
